import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { useState } from "react";
import { css } from "styled-components";

/* Poolcorp Custom Code */
import Clickable from "@insite/mobius/Clickable";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import { useAnalytics } from "@store/Hooks/Common";
import useCurrentPage from "@store/Hooks/Common/useCurrentPage";
import useCurrentCurrency from "@store/Hooks/Context/useCurrentCurrency";
import useIsSearchPage from "@store/Hooks/ProductList/useIsSearchPage";
import { useIsCategoryPage } from "@store/Pages/ProductList/Hooks";
/* Poolcorp Custom Code */

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductDescriptionStyles;
    // Poolcorp Custom Code
    hideLink?: boolean;
}

type Props = OwnProps;

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
            `,
        },
    },
};

const ProductDescription = ({
    product,
    onClick,
    extendedStyles,
    // Poolcorp Custom Code
    hideLink,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productDescriptionStyles, extendedStyles));

    /* Poolcorp Custom Code */
    const { dispatchProductClickEvent } = useAnalytics();
    const currentPage = useCurrentPage();
    const isSearchPage = useIsSearchPage();
    const isCategoryPage = useIsCategoryPage();
    const history = useHistory();
    const currentCurency = useCurrentCurrency() || undefined;
    const handleAnalyticsClick = () => {
        if ("product" in product) {
            dispatchProductClickEvent(product as ProductContextModel, 1, currentPage, isCategoryPage, isSearchPage, currentCurency?.currencyCode);
            return;
        }
        if (product) {
            dispatchProductClickEvent(product, 1, currentPage, isCategoryPage, isSearchPage, currentCurency?.currencyCode);
        }
    };
    /* Poolcorp Custom Code */

    const description =
        "product" in product
            ? product.product.productTitle
            : product.shortDescription || ("description" in product ? product.description : "");
    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;

    /* Poolcorp Custom Code */
    const onClickDescription = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onClick?.(event);
        event.preventDefault();
        handleAnalyticsClick();

        if (!productDetailPath) {
            return;
        }
        if (productDetailPath.startsWith("http")) {
            window.location.href = productDetailPath;
        } else {
            history.push(productDetailPath);
        }
        
        return false;
    };
    /* Poolcorp Custom Code */

    return productDetailPath && (!("isActiveProduct" in product) || product.isActiveProduct) && !hideLink /* Poolcorp Custom Code */ ? (
        <Link
            {...styles.productDetailLink}
            href={productDetailPath}
            alt={`See product details for ${description}`}
            data-test-selector="productDescriptionLink"
            onClick={onClickDescription} // Poolcorp Custom Code
        >
            {description}
        </Link>
    ) : (
        <Typography {...styles.productDetailDescription}>{description}</Typography>
    );
};

export default ProductDescription;
